import moment from 'moment';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { getPAIAH010_2, getPAIAH020, putPAIAH020, putPAIAH020ChangePassword } from '../../../services/Api';
import AddressCustom from '../../../shared/components/AddressCustom';
import Dropdown from '../../../shared/components/Dropdown';
import SideNav from '../../../shared/components/SideNav';
import { decodeToken, generateYearOptions, handleFocus } from '../../../utils';

const PAIAH020 = () => {
    const navigate = useNavigate();
    const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
    const [data, setData] = useState({});
    const [telNo, setTelNo] = useState({ part1: '', part2: '', part3: '' });
    const [mobileNo, setMobileNo] = useState({ mobileNoPart1: '', mobileNoPart2: '', mobileNoPart3: '' });
    const [email, setEmail] = useState({ emailPart1: '', emailPart2: '', domain: '' });
    const [bizNo, setBizNo] = useState({ part1: '', part2: '', part3: '' });
    const [appGbnCDOptions, setAppGbnCDOptions] = useState([]);
    const [password, setPassword] = useState('');
    const [changePassword, setChangePassword] = useState({});
    const [isOpenPopup, setIsOpenPopup] = useState(false);
    const [oldLicenseNo, setOldLicenseNo] = useState('');
    const token = useSelector(({ auth }) => auth.login.token);
    const decode = decodeToken(token);
    const [role, setRole] = useState('');

    const currentYear = moment().year();
    const yearOptions = generateYearOptions(currentYear - 100, currentYear);

    useEffect(() => {
        if (decode?.authorities === 'ROLE_P') {
            setRole('P');
        }
        if (decode?.authorities === 'ROLE_C') {
            setRole('C');
        }
    }, [decode]);
    // const openPostcodePopup = useDaumPostcodePopup();

    const handleComplete = (data) => {
        const address = data.address;
        const postNo = data.zonecode;
        const addressExtra = data.bname;
        const addressRoad = data.roadAddress;

        setData((prevData) => ({ ...prevData, postNo, addressRoad, addressExtra, address }));
    };

    const handleSearchAddress = () => {
        // openPostcodePopup({
        //     onComplete: handleComplete,
        //     popupTitle: '델탈잡 채용광고 지도',
        // });
        setIsAddressModalOpen(true);
    };

    const getListData = () => {
        getPAIAH020()
            .then(({ data }) => {
                setData(data);
                if (data.telNo) {
                    const [part1, part2, part3] = data.telNo.split('-');
                    setTelNo({ part1, part2, part3 });
                }
                if (data.mobileNo) {
                    const [mobileNoPart1, mobileNoPart2, mobileNoPart3] = data.mobileNo.split('-');
                    setMobileNo({ mobileNoPart1, mobileNoPart2, mobileNoPart3 });
                }

                if (data.bizNo) {
                    const [bizNoPart1, bizNoPart2, bizNoPart3] = data.bizNo.split('-');
                    setData((prevData) => ({ ...prevData, bizNoPart1, bizNoPart2, bizNoPart3 }));
                }

                if (data.email) {
                    const [emailPart1, emailPart2] = data.email.split('@');
                    const domainOptions = getOptions('EmailDomain').map((option) => option.value);
                    const domain = domainOptions.includes(emailPart2) ? emailPart2 : 'zdirect';
                    setEmail({ emailPart1, emailPart2, domain: domain === emailPart2 ? domain : 'zdirect' });
                }
                if (data.codes) {
                    const appGbnCDOptions = data.codes.map((code) => ({
                        id: `AppGbnCD_${code.code}`,
                        option: code.codeName,
                        value: code.code,
                    }));
                    setAppGbnCDOptions(appGbnCDOptions);
                }
                if (data.licenseNo === '') {
                    setData((prevData) => ({ ...prevData, licenseNoNone: 'None' }));
                }
            })
            .catch((error) => console.log(error));
    };

    const getOptions = (name) => {
        const options = {
            AppGbnCD: appGbnCDOptions,
            TelNo: [
                { id: 'TelNo_02', option: '02', value: '02' },
                { id: 'TelNo_031', option: '031', value: '031' },
                { id: 'TelNo_032', option: '032', value: '032' },
                { id: 'TelNo_033', option: '033', value: '033' },
                { id: 'TelNo_041', option: '041', value: '041' },
                { id: 'TelNo_042', option: '042', value: '042' },
                { id: 'TelNo_043', option: '043', value: '043' },
                { id: 'TelNo_044', option: '044', value: '044' },
                { id: 'TelNo_051', option: '051', value: '051' },
                { id: 'TelNo_052', option: '052', value: '052' },
                { id: 'TelNo_053', option: '053', value: '053' },
                { id: 'TelNo_054', option: '054', value: '054' },
                { id: 'TelNo_055', option: '055', value: '055' },
                { id: 'TelNo_061', option: '061', value: '061' },
                { id: 'TelNo_062', option: '062', value: '062' },
                { id: 'TelNo_063', option: '063', value: '063' },
                { id: 'TelNo_064', option: '064', value: '064' },
                { id: 'TelNo_070', option: '070', value: '070' },
                { id: 'TelNo_010', option: '010', value: '010' },
                { id: 'TelNo_011', option: '011', value: '011' },
                { id: 'TelNo_016', option: '016', value: '016' },
                { id: 'TelNo_017', option: '017', value: '017' },
                { id: 'TelNo_018', option: '018', value: '018' },
                { id: 'TelNo_019', option: '019', value: '019' },
            ],
            MobileNo: [
                { id: 'MobileNo_010', option: '010', value: '010' },
                { id: 'MobileNo_011', option: '011', value: '011' },
                { id: 'MobileNo_016', option: '016', value: '016' },
                { id: 'MobileNo_017', option: '017', value: '017' },
                { id: 'MobileNo_018', option: '018', value: '018' },
                { id: 'MobileNo_019', option: '019', value: '019' },
            ],
            EmailDomain: [
                { id: 'EmailDomain_zdirect', option: '직접입력', value: 'zdirect' },
                { id: 'EmailDomain_gmail.com', option: 'gmail.com', value: 'gmail.com' },
                { id: 'EmailDomain_hotmail.com', option: 'hotmail.com', value: 'hotmail.com' },
                { id: 'EmailDomain_msn.com', option: 'msn.com', value: 'msn.com' },
                { id: 'EmailDomain_nate.com', option: 'nate.com', value: 'nate.com' },
                { id: 'EmailDomain_naver.com', option: 'naver.com', value: 'naver.com' },
                { id: 'EmailDomain_yahoo.com', option: 'yahoo.com', value: 'yahoo.com' },
            ],
            School: [
                { option: '서울대', value: '서울대' },
                { option: '경희대', value: '경희대' },
                { option: '연세대', value: '연세대' },
                { option: '조선대', value: '조선대' },
                { option: '경북대', value: '경북대' },
                { option: '부산대', value: '부산대' },
                { option: '전남대', value: '전남대' },
                { option: '전북대', value: '전북대' },
                { option: '원광대', value: '원광대' },
                { option: '단국대', value: '단국대' },
                { option: '강릉원주대', value: '강릉원주대' },
                { option: '기타', value: '기타' },
            ],
        };
        return options[name];
    };

    const appGbnLabel =
        getOptions('AppGbnCD').find(
            option => String(option.value) === String(data.appGbnCd)
        )?.option || "";

    const handleCheckboxChange = (selectedValue, name) => {
        setData((checkedValues) => ({
            ...checkedValues,
            [name]: selectedValue,
        }));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (
            (name === 'bizNoPart1' && value.length > 3) ||
            (name === 'bizNoPart2' && value.length > 2) ||
            (name === 'bizNoPart3' && value.length > 5)
        ) {
            return;
        }

        setData((prevData) => {
            const newData = {
                ...prevData,
                [name]: value,
            };

            if (name === 'bizNoPart1' || name === 'bizNoPart2' || name === 'bizNoPart3') {
                newData.bizNo = `${newData.bizNoPart1}-${newData.bizNoPart2}-${newData.bizNoPart3}`;
                setBizNo(newData.bizNo);
            }

            return newData;
        });
    };

    const toggleLicenseNoNone = () => {
        setData((prevData) => {
            const newLicenseNoNone = prevData.licenseNoNone === 'None' ? '' : 'None';
            if (newLicenseNoNone === 'None') {
                setOldLicenseNo(prevData.licenseNo);
            }
            return {
                ...prevData,
                licenseNoNone: newLicenseNoNone,
                licenseNo: newLicenseNoNone === 'None' ? '' : oldLicenseNo,
            };
        });
    };

    const toggleBizNoNone = () => {
        setData((prevData) => {
            const newBizNoNone = prevData.bizNoNone === 'None' ? '' : 'None';
            if (newBizNoNone === 'None') {
                setBizNo({ part1: '', part2: '', part3: '' });
            }
            return {
                ...prevData,
                bizNoNone: newBizNoNone,
                bizNo: newBizNoNone === 'None' ? '' : `${bizNo.part1}-${bizNo.part2}-${bizNo.part3}`,
            };
        });
    };

    const handleTelDownChange = (selectedValue) => {
        if (selectedValue === '00') {
            setTelNo((prevTelNo) => ({
                ...prevTelNo,
                part1: '',
            }));
        } else {
            setTelNo((prevTelNo) => ({
                ...prevTelNo,
                part1: selectedValue,
            }));
        }
    };

    const handleTelChange = (e) => {
        const { name, value } = e.target;
        setTelNo((prevTelNo) => ({
            ...prevTelNo,
            [name]: value,
        }));
    };

    const handleMobileDownChange = (selectedValue) => {
        setMobileNo((prevMobileNo) => ({
            ...prevMobileNo,
            mobileNoPart1: selectedValue,
        }));
    };

    const handleMobileChange = (e) => {
        const { name, value } = e.target;
        setMobileNo((prevMobileNo) => ({
            ...prevMobileNo,
            [name]: value,
        }));
    };

    const handleEmailDomainChange = (selectedValue) => {
        setEmail((prevEmail) => ({
            ...prevEmail,
            domain: selectedValue,
            emailPart2: selectedValue === 'zdirect' ? '' : selectedValue,
        }));
    };

    const handleEmailChange = (e) => {
        const { name, value } = e.target;
        setEmail((prevEmail) => ({
            ...prevEmail,
            [name]: value,
        }));
    };

    const handleRadioChange = (e) => {
        const { name, value } = e.target;
        setData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleChangePassword = (e) => {
        const { name, value } = e.target;
        if (name === 'oldPassword') {
            setPassword(value);
        }
        setChangePassword((prevChangePassword) => ({
            ...prevChangePassword,
            [name]: value,
        }));
    };

    const residentNo = data.residentNo || '';
    let birthDate = moment(residentNo, 'YYMMDD');

    if (birthDate.isAfter(moment())) {
        birthDate = birthDate.subtract(100, 'years');
    }

    const year = birthDate.format('YYYY');
    const month = birthDate.format('MM');
    const day = birthDate.format('DD');

    useEffect(() => {
        getListData();
        // eslint-disable-next-line
    }, []);

    const handleSave = async () => {
        if (password === '') {
            alert('비밀번호를 입력해 주세요.');
            handleFocus('passwordWantChange');
            return;
        }

        if (data.appGbnCd === '110' && data.licenseNo === '') {
            setData((prevData) => ({
                ...prevData,
                licenseNoNone: '',
            }));
            alert('회원구분이 치과의사인 경우 면허번호는 필수항목입니다.\n면허/자격증번호를 올바르게 입력해 주세요.');
            handleFocus('licenseNo');
            return;
        }
        if (
            (role === 'C' && data.appGbnCd === '110' && data.school === '') ||
            (role === 'C' && data.school === '기타' && data.schoolEtc === '') ||
            (role === 'C' && data.appGbnCd === '110' && data.graduateYear === '')
        ) {
            alert('학교정보를 빠짐없이 입력해 주세요.');
            if (data.school === '기타' && data.schoolEtc === '') {
                handleFocus('schoolEtc');
            } else {
                handleFocus('school');
            }
            return;
        }

        if (data.appGbnCd !== '110') {
            data.school = '';
            data.graduateYear = '';
            data.schoolEtc = '';
        }

        const updatedData = {
            ...data,
            telNo: `${telNo.part1}-${telNo.part2}-${telNo.part3}`,
            mobileNo: `${mobileNo.mobileNoPart1}-${mobileNo.mobileNoPart2}-${mobileNo.mobileNoPart3}`,
            email: `${email.emailPart1}@${email.emailPart2}`,
        };

        const validateEmail = (emailPart1, emailPart2) => {
            let email = emailPart1 + '@' + emailPart2;
            const emailRegex =
                /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
            if (!email) {
                return false;
            }
            if (email.length > 50) {
                return false;
            }
            return emailRegex.test(email);
        };

        setData(updatedData);

        try {
            const response = await getPAIAH010_2({ params: { plainPassword: password } });

            if (response?.data === false) {
                window.alert('비밀번호가 일치하지 않습니다.');
                handleFocus('passwordWantChange');
                return;
            }
            if (!data.licenseNo && data.licenseNoNone !== 'None' && data.licenseNoNone !== 'NONE') {
                window.alert('면허번호를 입력해 주세요.');
                handleFocus('licenseNo');
                return;
            }
            if (!data.bizCompany) {
                window.alert('근무처를 입력해 주세요.');
                handleFocus('bizCompany');
                return;
            }

            if (
                (!data.bizNoPart1 || !data.bizNoPart2 || !data.bizNoPart3) &&
                data.bizNoNone !== 'None' &&
                data.bizNoNone !== 'NONE' &&
                role === 'C'
            ) {
                window.alert('사업자등록번호를 입력해 주세요.');
                if (!data.bizNoPart1) {
                    handleFocus('bizNoPart1');
                    return;
                }
                if (!data.bizNoPart2) {
                    handleFocus('bizNoPart2');
                    return;
                }
                if (!data.bizNoPart3) {
                    handleFocus('bizNoPart3');
                    return;
                }
            }

            if (mobileNo.mobileNoPart1 === '') {
                window.alert('휴대폰 번호를 입력해 주세요.');
                handleFocus('mobileNoPart1');
                return;
            }
            if (mobileNo.mobileNoPart2 === '') {
                window.alert('휴대폰 번호를 입력해 주세요.');
                handleFocus('mobileNoPart2');
                return;
            }
            if (mobileNo.mobileNoPart3 === '') {
                window.alert('휴대폰 번호를 입력해 주세요.');
                handleFocus('mobileNoPart3');
                return;
            }

            if (email.emailPart1 === '') {
                window.alert('이메일을 입력해 주세요..');
                handleFocus('emailPart1');
                return;
            }
            if (email.emailPart2 === '') {
                window.alert('이메일을 입력해 주세요..');
                handleFocus('emailPart2');
                return;
            }
            if (!validateEmail(email.emailPart1, email.emailPart2)) {
                window.alert('이메일주소가 올바르지 않습니다.');
                handleFocus('emailPart2');
                return;
            }

            const { bizNoPart1, bizNoPart2, bizNoPart3, ...payload } = updatedData;

            putPAIAH020(payload)
                .then(() => {
                    window.alert('수정되었습니다.');
                    if (role === 'P') {
                        navigate('/paiaa010');
                    } else {
                        navigate('/pajaa010');
                    }
                })
                .catch((error) => console.log(error));
        } catch (error) {
            console.log(error);
        }
    };
    const handleCancel = () => {
        const confirmLeave = window.confirm(
            '내 정보 수정 페이지에서 나가시겠습니까?\n변경한 사항이 있다면 저장되지 않고 페이지를 나가게 됩니다.',
        );
        if (confirmLeave) {
            if (role === 'P') {
                navigate('/paiaa010');
            } else {
                navigate('/pajaa010');
            }
        }
    };

    const validatePassword = (password, changePassword) => {
        const oldPassword = password || changePassword.oldPassword;
        const passwordRegex = /^.{4,12}$/;

        if (!oldPassword) {
            window.alert('현재 비밀번호를 입력해 주세요.');
            handleFocus('oldPassword');
            return false;
        }
        if (!changePassword.newPassword) {
            window.alert('신규 비밀번호를 입력해 주세요.');
            handleFocus('newPassword');
            return false;
        }
        if (!passwordRegex.test(changePassword.newPassword)) {
            window.alert('비밀번호 입력규칙을 다시 한번 확인해 주세요.');
            handleFocus('newPassword');
            return false;
        }
        if (!changePassword.confirmNewPassword) {
            window.alert('신규 비밀번호를 한번 더 입력해 주세요');
            handleFocus('confirmNewPassword');
            return false;
        }

        if (changePassword.newPassword !== changePassword.confirmNewPassword) {
            window.alert('입력하신 신규 비밀번호와 신규 비밀번호 확인이 일치하지 않습니다.');
            handleFocus('confirmNewPassword');
            return false;
        }

        if (changePassword.newPassword === oldPassword) {
            window.alert('새 비밀번호는 기존 비밀번호와 일치할 수 없습니다.');
            handleFocus('newPassword');
            return false;
        }

        return true;
    };

    const closePopup = () => {
        setIsOpenPopup(false);
        setChangePassword({
            oldPassword: password,
            newPassword: '',
            confirmNewPassword: '',
        });
    };

    const submitChangePassword = async () => {
        const oldPassword = password || changePassword.oldPassword;
        if (password === '' || changePassword.oldPassword === '') {
            window.alert('현재 비밀번호를 입력해 주세요.');
            handleFocus('oldPassword');
            return;
        }
        const response = await getPAIAH010_2({ params: { plainPassword: password } });
        if (response?.data === false) {
            window.alert('현재 비밀번호가 올바르지 않습니다.');
            handleFocus('oldPassword');
            return;
        }

        if (!validatePassword(password, changePassword)) {
            return;
        }

        const { confirmNewPassword, ...payload } = changePassword;

        await putPAIAH020ChangePassword({ seq: data.seq, oldPassword, ...payload }).then(() => {
            window.alert('비밀번호가 변경되었습니다');
            closePopup();
        });
    };

    return (
        <>
            <div>
                <div id="content" className="sub-page">
                    <div className="container">
                        <div id="top-sub-page">
                            <SideNav />
                            <div className="resume">
                                <div className="resume__inner">
                                    <h3 className="resume__tit">내 정보 수정 <span className="red">※ 수정이 불가한 항목에 대해서는 이메일 문의로 별도 요청 부탁드립니다.</span></h3>

                                    <div className="mdf mdf--mt18">
                                        <div className="mdf__container">
                                            <div className="mdf__grid2">
                                                <div className="mdf__sbj pt0">
                                                    <span className="mdf__blue">*</span>
                                                    회원그룹구분
                                                </div>
                                                <div className="mdf__div">
                                                    <span className="mdf__blue">
                                                        {role === 'P' ? '개인회원' : '치과회원'}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="mdf__grid2">
                                                <div className="mdf__sbj pt0">
                                                    <span className="mdf__red">*</span>
                                                    아이디
                                                </div>
                                                <div className="mdf__div">
                                                    <span className="mdf__blue">{data?.memberId} (통합회원)</span>
                                                </div>
                                            </div>
                                            <div className="mdf__grid2">
                                                <div className="mdf__sbj">
                                                    <span className="mdf__red">*</span>
                                                    비밀번호
                                                </div>
                                                <div className="mdf__div">
                                                    <div className="mdf__item">
                                                        <input
                                                            type="password"
                                                            name="passwordWantChange"
                                                            className="mdf__input"
                                                            placeholder="비밀번호 입력"
                                                            onChange={(e) => {
                                                                setPassword(e.target.value);
                                                                setChangePassword((prevChangePassword) => ({
                                                                    ...prevChangePassword,
                                                                    oldPassword: e.target.value,
                                                                }));
                                                            }}
                                                        />
                                                        <button
                                                            type="button"
                                                            className="mdf__change"
                                                            id="pwChange"
                                                            onClick={() => setIsOpenPopup(true)}
                                                        >
                                                            비밀번호 변경
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="mdf__grid2">
                                                <div className="mdf__sbj">
                                                    <span className="mdf__blue">*</span>
                                                    이름
                                                </div>
                                                <div className="mdf__div">
                                                    <div className="mdf__item">
                                                        <input
                                                            type="text"
                                                            className="mdf__input"
                                                            value={data?.nameKor || ''}
                                                            readOnly
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="mdf__grid2">
                                                <div className="mdf__sbj">
                                                    <span className="mdf__blue">*</span>
                                                    생년월일
                                                </div>
                                                <div className="mdf__div">
                                                    <div className="mdf__item max-wd246">
                                                        <div className="mdf__select-readonly">{year}</div>
                                                        <div className="mdf__select-readonly">{month}</div>
                                                        <div className="mdf__select-readonly">{day}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="mdf__grid2">
                                                <div className="mdf__sbj">
                                                    <span className="mdf__red">*</span>
                                                    회원구분
                                                </div>
                                                <div className="mdf__div">
                                                    <div className="mdf__item">
                                                        <input
                                                            type="text"
                                                            className="mdf__input"
                                                            value={appGbnLabel}
                                                            readOnly
                                                        />
                                                    </div>
                                                </div>
                                                {/* <div className="mdf__div">
                                                    <div className="mdf__item max-wd246">
                                                        <Dropdown
                                                            options={getOptions('AppGbnCD')}
                                                            placeholder="선택"
                                                            name="appGbnCd"
                                                            value={data.appGbnCd}
                                                            onChange={handleCheckboxChange}
                                                        />
                                                    </div>
                                                </div> */}
                                            </div>
                                            <div className="mdf__grid2">
                                                <div className="mdf__sbj">
                                                    <span className="mdf__red">*</span>
                                                    면허번호
                                                </div>
                                                <div className="mdf__div">
                                                    <div className="mdf__item">
                                                        <input
                                                            type="number"
                                                            className="mdf__input"
                                                            value={data?.licenseNo || ''}
                                                            disabled={
                                                                data?.licenseNoNone === 'None' ||
                                                                data?.licenseNoNone === 'NONE'
                                                            }
                                                            name="licenseNo"
                                                            maxLength={10}
                                                            onChange={(e) => {
                                                                const value = e.target.value;

                                                                if (/^\d*$/.test(value) && value.length <= 10) {
                                                                    handleInputChange(e);
                                                                }
                                                            }}
                                                        />
                                                        <label className="mdf__label" htmlFor="noneLicense">
                                                            <input
                                                                type="checkbox"
                                                                id="noneLicense"
                                                                value={data?.licenseNoNone || ''}
                                                                checked={
                                                                    data?.licenseNoNone === 'None' ||
                                                                        data?.licenseNoNone === 'NONE'
                                                                        ? true
                                                                        : false
                                                                }
                                                                name="licenseNoNone"
                                                                onChange={toggleLicenseNoNone}
                                                            />
                                                            없음
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            {data?.appGbnCd === '110' && role === 'C' && (
                                                <div className="mdf__grid2">
                                                    <div className="mdf__sbj">
                                                        <span className="mdf__red">*</span>
                                                        학교 정보
                                                    </div>
                                                    <div className="mdf__div">
                                                        <div className="mdf__item mdf__item--grid">
                                                            <Dropdown
                                                                placeholder="졸업 학교 선택"
                                                                options={getOptions('School')}
                                                                name="school"
                                                                id="school"
                                                                value={data?.school || ''}
                                                                className="wd140"
                                                                onChange={(valueOption) => {
                                                                    handleInputChange({
                                                                        target: {
                                                                            name: 'school',
                                                                            value: valueOption,
                                                                        },
                                                                    });
                                                                }}
                                                            />
                                                            <input
                                                                type="text"
                                                                placeholder="직접 입력"
                                                                name="schoolEtc"
                                                                value={data?.schoolEtc}
                                                                maxLength={100}
                                                                disabled={data?.school !== '기타'}
                                                                onChange={handleInputChange}
                                                                className="mdf__input"
                                                            />
                                                            졸업 연도:
                                                            <Dropdown
                                                                placeholder="졸업 연도 선택"
                                                                options={yearOptions}
                                                                name="graduateYear"
                                                                value={data?.graduateYear}
                                                                className="wd140"
                                                                onChange={(valueOption) => {
                                                                    handleInputChange({
                                                                        target: {
                                                                            name: 'graduateYear',
                                                                            value: valueOption,
                                                                        },
                                                                    });
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            <div className="mdf__grid2">
                                                <div className="mdf__sbj">
                                                    <span className="mdf__red">*</span>
                                                    근무처(소속)
                                                </div>
                                                <div className="mdf__div">
                                                    <div className="mdf__item">
                                                        <input
                                                            type="text"
                                                            className="mdf__input"
                                                            name="bizCompany"
                                                            value={data?.bizCompany || ''}
                                                            onChange={handleInputChange}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            {role === 'C' && (
                                                <div className="mdf__grid2">
                                                    <div className="mdf__sbj">
                                                        <span className="mdf__red">*</span>
                                                        사업자등록번호
                                                    </div>
                                                    <div className="mdf__div">
                                                        <div className="mdf__item">
                                                            <div className="mdf__item">
                                                                <input
                                                                    type="number"
                                                                    className="mdf__input"
                                                                    name="bizNoPart1"
                                                                    maxLength={3}
                                                                    value={
                                                                        data.bizNoNone === 'None' ||
                                                                            data.bizNoNone === 'NONE'
                                                                            ? ''
                                                                            : data.bizNoPart1 || ''
                                                                    }
                                                                    onChange={handleInputChange}
                                                                    disabled={
                                                                        data.bizNoNone === 'None' ||
                                                                        data.bizNoNone === 'NONE'
                                                                    }
                                                                />
                                                            </div>
                                                            <span>-</span>
                                                            <div className="mdf__item">
                                                                <input
                                                                    type="number"
                                                                    className="mdf__input"
                                                                    name="bizNoPart2"
                                                                    maxLength={2}
                                                                    value={
                                                                        data.bizNoNone === 'None' ||
                                                                            data.bizNoNone === 'NONE'
                                                                            ? ''
                                                                            : data.bizNoPart2 || ''
                                                                    }
                                                                    onChange={handleInputChange}
                                                                    disabled={
                                                                        data.bizNoNone === 'None' ||
                                                                        data.bizNoNone === 'NONE'
                                                                    }
                                                                />
                                                            </div>
                                                            <span>-</span>
                                                            <div className="mdf__item">
                                                                <input
                                                                    type="number"
                                                                    className="mdf__input"
                                                                    name="bizNoPart3"
                                                                    maxLength={5}
                                                                    value={
                                                                        data.bizNoNone === 'None' ||
                                                                            data.bizNoNone === 'NONE'
                                                                            ? ''
                                                                            : data.bizNoPart3 || ''
                                                                    }
                                                                    onChange={handleInputChange}
                                                                    disabled={
                                                                        data.bizNoNone === 'None' ||
                                                                        data.bizNoNone === 'NONE'
                                                                    }
                                                                />
                                                            </div>
                                                            <label className="mdf__label" htmlFor="bizNoNone">
                                                                <input
                                                                    type="checkbox"
                                                                    id="bizNoNone"
                                                                    value={data?.bizNoNone || ''}
                                                                    checked={
                                                                        data?.bizNoNone === 'None' ||
                                                                            data?.bizNoNone === 'NONE'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                    name="bizNoNone"
                                                                    onChange={toggleBizNoNone}
                                                                />
                                                                없음
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            <div className="mdf__grid2">
                                                <div className="mdf__sbj">연락처</div>
                                                <div className="mdf__div">
                                                    <div className="mdf__item max-wd246">
                                                        <Dropdown
                                                            placeholder=""
                                                            options={getOptions('TelNo')}
                                                            value={telNo.part1}
                                                            name="part1"
                                                            onChange={handleTelDownChange}
                                                        />
                                                        <span className="mdf__oh">-</span>
                                                        <input
                                                            type="text"
                                                            className="mdf__input"
                                                            maxLength={4}
                                                            inputMode="numeric"
                                                            pattern="[0-9]*"
                                                            name="part2"
                                                            value={telNo.part2 || ''}
                                                            onChange={(e) => {
                                                                const onlyNums = e.target.value.replace(/\D/g, "");
                                                                handleTelChange({ target: { name: "part2", value: onlyNums } });
                                                            }}
                                                        />

                                                        <span className="mdf__oh">-</span>
                                                        <input
                                                            type="text"
                                                            className="mdf__input"
                                                            maxLength={4}
                                                            inputMode="numeric"
                                                            pattern="[0-9]*"
                                                            name="part3"
                                                            value={telNo.part3 || ''}
                                                            onChange={(e) => {
                                                                const onlyNums = e.target.value.replace(/\D/g, "");
                                                                handleTelChange({ target: { name: "part3", value: onlyNums } });
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="mdf__grid2">
                                                <div className="mdf__sbj">
                                                    <span className="mdf__red">*</span>
                                                    휴대폰
                                                </div>
                                                <div className="mdf__div">
                                                    <div className="mdf__item max-wd246">
                                                        <Dropdown
                                                            placeholder=""
                                                            options={getOptions('MobileNo')}
                                                            name="mobileNoPart1"
                                                            value={mobileNo.mobileNoPart1}
                                                            onChange={handleMobileDownChange}
                                                        />
                                                        <span className="mdf__oh">-</span>
                                                        <input
                                                            type="text"
                                                            className="mdf__input"
                                                            maxLength={4}
                                                            inputMode="numeric"
                                                            pattern="[0-9]*"
                                                            name="mobileNoPart2"
                                                            value={mobileNo.mobileNoPart2 || ''}
                                                            onChange={(e) => {
                                                                const onlyNums = e.target.value.replace(/\D/g, "");
                                                                handleMobileChange({ target: { name: "mobileNoPart2", value: onlyNums } });
                                                            }}
                                                        />

                                                        <span className="mdf__oh">-</span>
                                                        <input
                                                            type="text"
                                                            className="mdf__input"
                                                            maxLength={4}
                                                            inputMode="numeric"
                                                            pattern="[0-9]*"
                                                            name="mobileNoPart3"
                                                            value={mobileNo.mobileNoPart3 || ''}
                                                            onChange={(e) => {
                                                                const onlyNums = e.target.value.replace(/\D/g, "");
                                                                handleMobileChange({ target: { name: "mobileNoPart3", value: onlyNums } });
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="mdf__grid2" style={{ alignItems: 'start' }}>
                                                <div className="mdf__sbj">
                                                    <span className="mdf__red">*</span>
                                                    이메일
                                                </div>
                                                <div className="mdf__div">
                                                    <div className="mdf__item mdf__item--grid">
                                                        <input
                                                            type="text"
                                                            className="mdf__input wd127"
                                                            name="emailPart1"
                                                            value={email.emailPart1 || ''}
                                                            onChange={handleEmailChange}
                                                        />
                                                        <span className="mdf__oh">@</span>
                                                        <input
                                                            type="text"
                                                            className="mdf__input wd127"
                                                            name="emailPart2"
                                                            value={email.emailPart2 || ''}
                                                            onChange={handleEmailChange}
                                                        />
                                                        <Dropdown
                                                            placeholder=""
                                                            options={getOptions('EmailDomain')}
                                                            className={'wd130'}
                                                            value={email.domain}
                                                            onChange={handleEmailDomainChange}
                                                        />
                                                    </div>
                                                    <p className="mdf__note">
                                                        ※ hanmail, gmail은 수신에 제한이 있을 수 있습니다. 다른 이메일을
                                                        입력해 주세요.
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="mdf__grid2" style={{ alignItems: 'start' }}>
                                                <div className="mdf__sbj">
                                                    <span className="mdf__red">*</span>
                                                    주소
                                                </div>
                                                <div className="mdf__div">
                                                    <div className="mdf__item">
                                                        <input
                                                            type="text"
                                                            className="mdf__input wd130"
                                                            placeholder="우편번호"
                                                            value={data.postNo || ''}
                                                            name="postNo"
                                                            onChange={handleInputChange}
                                                            readOnly
                                                        />
                                                        <button
                                                            type="button"
                                                            className="mdf__adr-btn"
                                                            onClick={handleSearchAddress}
                                                        >
                                                            우편번호 검색
                                                        </button>
                                                    </div>
                                                    <div className="mdf__item">
                                                        <input
                                                            type="text"
                                                            className="mdf__input wd-full"
                                                            placeholder="기본 주소"
                                                            value={data.addressRoad || ''}
                                                            name="addressRoad"
                                                            onChange={handleInputChange}
                                                            readOnly
                                                        />
                                                    </div>
                                                    <div className="mdf__item">
                                                        <input
                                                            type="text"
                                                            className="mdf__input wd-full"
                                                            placeholder="상세 주소"
                                                            name="addressDetail"
                                                            value={data?.addressDetail || ''}
                                                            onChange={handleInputChange}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="mdf__grid2">
                                                <div className="mdf__sbj">
                                                    <span className="mdf__red">*</span>
                                                    비타민 메일수신
                                                </div>
                                                <div className="mdf__div">
                                                    <div className="mdf__item gap30">
                                                        <label className="mdf__radio-label" htmlFor="mailY">
                                                            <input
                                                                type="radio"
                                                                name="vitaminLetter"
                                                                id="mailY"
                                                                value="Y"
                                                                checked={data.vitaminLetter === 'Y'}
                                                                onChange={handleRadioChange}
                                                            />
                                                            예
                                                        </label>
                                                        <label className="mdf__radio-label" htmlFor="mailN">
                                                            <input
                                                                type="radio"
                                                                name="vitaminLetter"
                                                                id="mailN"
                                                                value="N"
                                                                checked={data.vitaminLetter === 'N'}
                                                                onChange={handleRadioChange}
                                                            />
                                                            아니오
                                                        </label>
                                                        <p className="mdf__note">
                                                            ※ 비타민메일링은 매일매일 유용한 치과정보 이메일로 발송해
                                                            드리는 서비스 입니다.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="mdf__grid2">
                                                <div className="mdf__sbj">
                                                    <span className="mdf__red">*</span>
                                                    SMS 수신
                                                </div>
                                                <div className="mdf__div">
                                                    <div className="mdf__item gap30">
                                                        <label className="mdf__radio-label" htmlFor="smsY">
                                                            <input
                                                                type="radio"
                                                                name="smsSrv"
                                                                id="smsY"
                                                                value="Y"
                                                                checked={data.smsSrv === 'Y'}
                                                                onChange={handleRadioChange}
                                                            />
                                                            예
                                                        </label>
                                                        <label
                                                            className="mdf__radio-label"
                                                            htmlFor="smsN"
                                                            style={{ width: '73px' }}
                                                        >
                                                            <input
                                                                type="radio"
                                                                name="smsSrv"
                                                                id="smsN"
                                                                value="N"
                                                                checked={data.smsSrv === 'N'}
                                                                onChange={handleRadioChange}
                                                            />
                                                            아니오
                                                        </label>
                                                        <p className="mdf__note">
                                                            ※ 문자 수신 동의 시 덴탈비타민, 덴탈잡, DVmall 사이트의
                                                            다양한 할인 혜택을 받으실 수 있습니다.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mdf__bottom">
                                            회원 탈퇴를 원하실 경우 "
                                            <Link to="/paiah030" className="mdf__scs">
                                                회원탈퇴
                                            </Link>
                                            " 버튼을 클릭해 주세요.
                                        </div>
                                        <div className="mdf__btbx">
                                            <button type="button" className="mdf__btn" onClick={handleCancel}>
                                                취소
                                            </button>
                                            <button
                                                type="button"
                                                className="mdf__btn mdf__btn--blue"
                                                onClick={handleSave}
                                            >
                                                회원정보 수정
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {isOpenPopup && (
                    <div className="mdf-pop active" id="pwChangePop">
                        <div className="mdf-pop__container">
                            <h3 className="mdf-pop__tit">비밀번호 변경</h3>
                            <button type="button" className="mdf-pop__close pwChangePopClose" onClick={closePopup} />
                            <div className="mdf-pop__block">
                                <div className="mdf__grid2">
                                    <div className="mdf__sbj">
                                        <span className="mdf__red">*</span>
                                        현재 비밀번호
                                    </div>
                                    <div className="mdf__div">
                                        <div className="mdf__item">
                                            <input
                                                type="password"
                                                className="mdf__input wd-full"
                                                value={changePassword.oldPassword || ''}
                                                name="oldPassword"
                                                onChange={handleChangePassword}
                                                maxLength={12}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="mdf__grid2">
                                    <div className="mdf__sbj">
                                        <span className="mdf__red">*</span>
                                        신규 비밀번호
                                    </div>
                                    <div className="mdf__div">
                                        <div className="mdf__item">
                                            <input
                                                type="password"
                                                className="mdf__input wd-full"
                                                placeholder="4~12자리의 영문, 숫자, 특수문자 혼합 가능"
                                                name="newPassword"
                                                value={changePassword.newPassword || ''}
                                                onChange={handleChangePassword}
                                                maxLength={12}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="mdf__grid2">
                                    <div className="mdf__sbj">
                                        <span className="mdf__red">*</span>
                                        신규 비밀번호 확인
                                    </div>
                                    <div className="mdf__div">
                                        <div className="mdf__item">
                                            <input
                                                type="password"
                                                className="mdf__input wd-full"
                                                placeholder="신규 비밀번호를 한번 더 입력하세요."
                                                name="confirmNewPassword"
                                                value={changePassword.confirmNewPassword || ''}
                                                onChange={handleChangePassword}
                                                maxLength={12}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="mdf-pop__btbx">
                                <button
                                    type="button"
                                    className="mdf-pop__btn mdf-pop__btn--blue"
                                    onClick={submitChangePassword}
                                >
                                    수정
                                </button>
                                <button type="button" className="mdf-pop__btn pwChangePopClose" onClick={closePopup}>
                                    취소
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <AddressCustom
                isOpen={isAddressModalOpen}
                onClose={() => setIsAddressModalOpen(false)}
                onComplete={handleComplete}
            />
        </>
    );
};
export default PAIAH020;
